/**
 * 补码信息
 */

<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>补码记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
     <el-form-item label="搜索：">
       <el-input size="small" v-model="formInline.filename" placeholder="文件名称"></el-input>


      </el-form-item>
      <el-form-item label="补码时间：">
        <el-date-picker
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"

        range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </el-form-item>
      <el-form-item>
             <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small"   @selection-change="selectChange"  :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="80px">
      </el-table-column>
<!--      <el-table-column align="center"  prop="filenames" label="文件名称" width="400">-->

<!--      </el-table-column>-->
      <el-table-column align="center"  prop="packageNo" label="箱号">

      </el-table-column>
      <el-table-column align="center"  prop="pdfnames" label="合成文件名称" width="500">

      </el-table-column>
      <el-table-column align="center"  prop="orderDate" label="下单订单" >
        <div slot-scope="scope">
          {{scope.row.orderDate|timestampToTime}}
        </div>
      </el-table-column>
      <el-table-column  align="center" prop="receiveDate" label="接收时间" >
        <div slot-scope="scope">
          {{scope.row.receiveDate|timestampToTime}}
        </div>
      </el-table-column>
      <el-table-column  align="center" prop="bumaDate" label="补码时间" >
        <div slot-scope="scope">
          {{scope.row.bumaDate|timestampToTime}}
        </div>
      </el-table-column>


<!--      <el-table-column align="center" label="操作" min-width="150">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
<!--          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


  </div>
</template>

<script>
  import {
    Buma

  } from '../../api/ordersMG'
import Pagination from '../../components/Pagination'
export default {
  name: "orders",
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      formInline: {
        date:[],
        filename:"",
        pageNum: 1,
        pageSize: 10
      },
      date: '',
      // 选择数据
      selectdata: [],
      listData: [], //用户数据

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取订单列表
    getdata(parameter) {
      this.loading = true


      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      Buma(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })

    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    stautsFormat(row, column) {

      if (row.status === 0) {
        return '待合成'
      } else if (row.status === 1) {
        return '已合成'
      } else if (row.status === -1) {
        return '正在合成'
      }else if (row.status === 2) {
        return '已发货'
      }
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/orders/Buma.vue